import { Component, Input, OnInit } from '@angular/core';
import { Website } from '../website-builder/wedding';
import { Settings } from '../settings/settings';

@Component({
  selector: 'app-website-template1',
  templateUrl: './website-template1.component.html',
  styleUrls: ['./website-template1.component.scss']
})
export class WebsiteTemplate1Component implements OnInit {
  @Input() cssClass = '';
  @Input() website:Website;
  @Input() settings:Settings;
  @Input() groupedScheduleItems: any = [];
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/website-template1/website-template1.component.ts